import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    GeoFileImportStatusContract,
    GeoFileUploadContract,
} from '@polaris-customerweb/sharedcomponents.core';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';
import { GeoFileImport } from 'src/app/models/geo-file-import';

@Injectable({ providedIn: 'root' })
export class GeoFileImportResourceService {
    baseUrl: string;

    constructor(
        configService: ConfigService,
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.geoFileImport,
            'v1'
        );
    }

    uploadGeoFile(file: File): Observable<GeoFileUploadContract> {
        const formData = new FormData();
        formData.append('file', file);

        return this.http.post<GeoFileUploadContract>(
            this.routingHelpersService.combineUrl(this.baseUrl, 'uploads'),
            formData,
            {
                responseType: 'json',
            }
        );
    }

    importGeoFile(geoImport: GeoFileImport): Observable<void> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            'imports'
        );
        return this.http.post<undefined>(url, geoImport);
    }

    getImportStatus(
        sessionId: string
    ): Observable<GeoFileImportStatusContract> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            'imports',
            sessionId
        );
        return this.http.get<GeoFileImportStatusContract>(url);
    }
}
